import { motion } from "framer-motion";
import { FaTwitter } from "react-icons/fa";
import React, { useContext, useEffect } from "react";
import { AnswerContext, EaseContext, WidthContext } from "../App";
import { State } from "./KlimaContent";
import { getAndUpdateAverage } from "../libs/firebase";

interface Props {
  setCurrentState: (state: State) => void;
  setCurrentQuesNum: (num: number) => void;
}

export const ResultContent: React.FC<Props> = (props) => {
  const [score, setScore] = React.useState(0);
  const { answer, setAnswer } = useContext(AnswerContext);
  const [tweetText, setTweetText] = React.useState("");
  const [average, setAverage] = React.useState("-");
  useEffect(() => {
    (async () => {
      let _score = 0;
      _score += Number(answer.food);
      _score += Number(answer.carType) * Number(answer.carDistance);
      _score += Number(answer.airplaneFrequency);
      _score += Number(answer.leisure);
      _score += Number(answer.equipment);
      _score *= Number(answer.family);
      _score = Math.ceil(_score);
      setScore(_score);

      setTweetText(
        "私の年間Co2排出量は" + _score + "kg-CO2でした。%0A%0Aカーボンフットプリントばりぐっどくん%0Ahttps://vg-carbonfootprint.web.app/"
      );

      const _average = await getAndUpdateAverage(_score)
      if (_average !== -1 || !_average) {
        setAverage(`${_average}`);
      } else {
        setAverage("-")
      }
    })();
  }, []);

  const { setCurrentState, setCurrentQuesNum } = props;
  const handleClick = () => {
    setCurrentState("welcome");
    setCurrentQuesNum(0);
    window.scrollTo(0, 0);
  };

  const width = useContext(WidthContext);
  const ease = useContext(EaseContext);

  return (
    <motion.div
      initial={{ opacity: 0, x: width }} // 初期状態
      animate={{ opacity: 1, x: 0 }} // マウント時
      exit={{ x: 20 }} // アンマウント時
      transition={{
        duration: 0.5,
        ease: ease,
      }}
      className="w-full rounded-xl shadow-xl my-8 md:px-6 py-10 bg-slate-50 px-2"
    >
      <h2 className="text-center text-3xl font-semibold">結果発表</h2>
      <div className="flex justify-center pt-4 pb-4">
        <img src="/images/result.png" alt="welcome" className="h-44" />
      </div>
      <div>
        <div className="text-semibold text-center font-semibold">
          <div className="text-md">あなたの年間CO2排出量</div>
          <div className="text-5xl mt-1 flex items-end justify-center">
            {score}
            <span className="ml-1 text-lg">kg-co2</span>
          </div>
        </div>
      </div>
      <div className="px-6 flex justify-center my-4">
        <a
          href={`https://twitter.com/intent/tweet?text=${tweetText}`}
          target="_blank"
          rel="noreferrer"
        >
          <button className="bg-[#1DA1F2] text-white rounded-md py-2 px-4 mt-4 flex items-center text-sm">
            <span className="mr-2">
              <FaTwitter size="18px" />
            </span>
            結果をツイートする
          </button>
        </a>
      </div>
      <h2 className="text-center text-xl font-semibold mt-10">
        みんなのCO2排出量
      </h2>
      <div className="flex flex-col items-center mt-4 gap-2">
        <div className="flex">
          <div className="font-semibold w-24 text-right">回答者の平均</div>
          <div className="ml-4">
            {average}<span className="ml-0.5 text-sm">kg-co2</span>
          </div>
        </div>
        <div className="flex">
          <div className="font-semibold w-24 text-right">日本の平均</div>
          <div className="ml-4">
            9186<span className="ml-0.5 text-sm">kg-co2</span>
          </div>
        </div>
      </div>
      <div className="flex justify-center mt-12 mb-3 px-4">
        <button className="btn w-full text-slate-50" onClick={handleClick}>
          もう一回あそぶ
        </button>
      </div>
    </motion.div>
  );
};
